import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export default function SmallTooltip({ title, children, ...props }: TooltipProps) {
  return (
    <Tooltip
      title={title}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '0.7rem',
            padding: '4px 8px',
            margin: '0px 5px !important',
            whiteSpace: 'nowrap',
          },
        },
        popper: {
          disablePortal: true,
          modifiers: [{ name: 'eventListeners', options: { scroll: true, resize: true } }],
        },
      }}
      disableFocusListener
      enterDelay={200}
      leaveDelay={0}
      placement="bottom"
      {...props}
    >
      {children}
    </Tooltip>
  );
}
